import { ReviewAverage } from '@app/interfaces/reviews.interface';
import { ReviewModel } from '@app/models/review.model';

export class ReviewInfosModel {
    public note: number;
    public averages: { [key: string]: ReviewAverage };
    public reviewCount: number;
    public reviews: ReviewModel[] = [];

    public addReview(review: ReviewModel): void {
        this.reviews.push(review);
    }

    public getReviews(offset: number = 0, limit: number = null): ReviewModel[] {
        return limit ? this.reviews.slice(offset, limit) : this.reviews;
    }

    public getAverages(): ReviewAverage[] {
        return Object.keys(this.averages).map((averageKey) => this.averages[averageKey]);
    }
}
